import { h, Fragment } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import { createPortal } from 'preact/compat'

const el = document.body.appendChild(document.createElement('div'))


export function Modal({ title, open, onClose, children }) {

	const modal = useRef()
	const [focusEl, setFocusEl] = useState(null)

	useEffect(() => {
		if (!modal.current) return
		if (open) {
			setFocusEl(document.activeElement)
			modal.current.focus()
		} else {
			focusEl && focusEl.focus()
		}
	}, [open])

	const onEsc = event => {
		if (!modal.current || !open) return
		const escKey = (event.key === 'Escape' || event.keyCode === 27)
		if (escKey) onClose && onClose()
	}

	useEffect(() => {
		window.addEventListener('keydown', onEsc)	
		return () => window.removeEventListener('keydown', onEsc)
	})

	return open && createPortal(<>
		<div class="modal__bg border-radius" onClick={() => onClose && onClose()}></div>
		<div ref={modal} class="modal" tabindex="-1">
			<div className="modal__header">
				<div className="modal__title">
					{title}
				</div>
				{onClose && <div className="modal__buttons">
					<button class="button button--icon-only button--icon-close" type="button" onClick={onClose}></button>
				</div>}
			</div>
			<div className="modal__body">
				{children}
			</div>
		</div>
	</>, el)
}